import { Directive, Input } from '@angular/core';
import { NG_VALIDATORS, Validator, ValidationErrors, UntypedFormGroup } from '@angular/forms';
import { ConfirmedValidator } from './confirmed-validator';



@Directive({
    selector: '[mustMatch]',
    providers: [{ provide: NG_VALIDATORS, useExisting: PasswordMustMatchDirective, multi: true }]
})
export class PasswordMustMatchDirective implements Validator {
    @Input('mustMatch') mustMatch: string[] = [];

    validate(formGroup: UntypedFormGroup): ValidationErrors {
        return ConfirmedValidator(this.mustMatch[0], this.mustMatch[1])(formGroup);
    }
}